module.exports = __webpack_public_path__ + "static/img/t16.45eb167b.png";